export const iconFontAwesomeUsersPeopleAddressBook = (
	<i className="fa-solid fa-address-book"></i>
);
